module.exports = __webpack_public_path__ + "static/media/immotech-mobile-screens.7dfa34ce.png";